"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beforeMaskedValueChange = exports.parseDOBFormatToNativeDateFormat = exports.parseNativeDateFormatToDOBFormat = exports.getOldestDOBInNativeDateFormat = exports.getOldestDOB = exports.getYoungestDOBInNativeDateFormat = exports.transformUserInput = exports.validators = exports.addLeadingZero = exports.parseDateInputValue = exports.convertISOStrToDOBStr = exports.convertDOBStrToISOStr = exports.NATIVE_DATE_FORMAT = exports.DOB_INPUT_FORMAT = void 0;
const date_fns_1 = require("date-fns");
const libs_utils_1 = require("@hotelplan/libs.utils");
exports.DOB_INPUT_FORMAT = 'dd/MM/yyyy';
exports.NATIVE_DATE_FORMAT = 'yyyy-MM-dd';
const convertDOBStrToISOStr = (dob) => {
    const date = (0, libs_utils_1.parseDateStr)(dob, exports.DOB_INPUT_FORMAT);
    return (0, libs_utils_1.formatDate)((0, date_fns_1.isValid)(date) ? date : new Date());
};
exports.convertDOBStrToISOStr = convertDOBStrToISOStr;
const convertISOStrToDOBStr = (iso) => {
    const date = (0, libs_utils_1.parseDateStr)(iso);
    return (0, libs_utils_1.formatDate)((0, date_fns_1.isValid)(date) ? date : new Date(), exports.DOB_INPUT_FORMAT);
};
exports.convertISOStrToDOBStr = convertISOStrToDOBStr;
const parseDateInputValue = (value) => {
    const res = value
        .replace(/_/g, '')
        .split('/')
        .map(x => ({ value: parseInt(x, 10) || 0, raw: x }));
    return res.filter(x => x.value !== 0).length === 0 ? null : res;
};
exports.parseDateInputValue = parseDateInputValue;
const addLeadingZero = (value) => {
    return `0${value.toString()}`.slice(-2);
};
exports.addLeadingZero = addLeadingZero;
exports.validators = {
    isNotFullyFilled(value) {
        return value.length < 3;
    },
    hasBlankParts(value) {
        const [day, month, year] = value;
        return (day.value === 0 ||
            month.value === 0 ||
            (year.value === 0 && year.raw.length !== 2));
    },
    hasInvalidDateParts(value) {
        const [day, month, year] = value;
        if (month.value > 12)
            return true;
        if (day.value > 31)
            return true;
        const yearStr = year.raw;
        if (yearStr.length === 4 && yearStr.startsWith('0'))
            return true;
        if (yearStr.length === 3 || yearStr.length === 1) {
            return true;
        }
        return false;
    },
    isUserDateAfterSomeDate(value, someDate) {
        const [day, month, year] = value;
        const userDate = new Date(year.value, month.value - 1, day.value);
        return (0, libs_utils_1.isAfter)(userDate, someDate);
    },
    isUserDateExists(value) {
        const [day, month, year] = value;
        return (0, libs_utils_1.isExists)(year.value, month.value - 1, day.value);
    },
};
const today = (0, libs_utils_1.getTodaysDate)();
const transformUserInput = (userInput) => {
    const value = (0, exports.parseDateInputValue)(userInput);
    if (!value)
        return '';
    if (exports.validators.isNotFullyFilled(value))
        return userInput;
    if (exports.validators.hasBlankParts(value))
        return '';
    // if (validators.hasInvalidDateParts(value)) return '';
    // if (validators.isUserDateAfterSomeDate(value, today)) return '';
    // Formatting
    const [day, month, year] = value;
    day.raw = day.value === 0 ? day.raw : (0, exports.addLeadingZero)(day.value);
    month.raw = month.value === 0 ? month.raw : (0, exports.addLeadingZero)(month.value);
    if (year.raw.length === 2) {
        const currentYear = today.getFullYear();
        const newDob = currentYear - year.value >= 2000
            ? `${day.raw}/${month.raw}/20${year.raw}`
            : `${day.raw}/${month.raw}/19${year.raw}`;
        return newDob;
    }
    return `${day.raw}/${month.raw}/${year.raw}`;
};
exports.transformUserInput = transformUserInput;
const getYoungestDOBInNativeDateFormat = () => {
    return (0, libs_utils_1.formatDate)(today, exports.NATIVE_DATE_FORMAT);
};
exports.getYoungestDOBInNativeDateFormat = getYoungestDOBInNativeDateFormat;
const getOldestDOB = (maxAge) => {
    return (0, libs_utils_1.subtractYears)((0, libs_utils_1.getTomorrowsDate)(), maxAge);
};
exports.getOldestDOB = getOldestDOB;
const getOldestDOBInNativeDateFormat = (maxAge) => {
    return (0, libs_utils_1.formatDate)((0, exports.getOldestDOB)(maxAge), exports.NATIVE_DATE_FORMAT);
};
exports.getOldestDOBInNativeDateFormat = getOldestDOBInNativeDateFormat;
const parseNativeDateFormatToDOBFormat = (dateStr) => {
    if (!dateStr)
        return '';
    const date = (0, libs_utils_1.parseDateStr)(dateStr, exports.NATIVE_DATE_FORMAT);
    return (0, libs_utils_1.formatDate)(date, exports.DOB_INPUT_FORMAT);
};
exports.parseNativeDateFormatToDOBFormat = parseNativeDateFormatToDOBFormat;
const parseDOBFormatToNativeDateFormat = (dateStr) => {
    const date = (0, libs_utils_1.parseDateStr)(dateStr, exports.DOB_INPUT_FORMAT);
    return (0, libs_utils_1.formatDate)(date, exports.NATIVE_DATE_FORMAT);
};
exports.parseDOBFormatToNativeDateFormat = parseDOBFormatToNativeDateFormat;
const SEPARATORS = [' ', '/', '-', '.', ','];
const beforeMaskedValueChange = (newState, oldState, userInput) => {
    var _a;
    if (SEPARATORS.includes(userInput)) {
        const cursorPosition = ((_a = newState.selection) === null || _a === void 0 ? void 0 : _a.start) || 0;
        const prevChar = newState.value[(cursorPosition || 1) - 1];
        if (prevChar.match(/[1-9]/) && cursorPosition < 5) {
            const newValueArr = newState.value.split('');
            newValueArr.splice(cursorPosition - 1, 1, '0');
            newValueArr.splice(cursorPosition, 1, prevChar);
            const newValue = newValueArr.join('');
            return Object.assign(Object.assign({}, newState), { value: newValue, selection: { start: cursorPosition + 2, end: cursorPosition + 2 } });
        }
        return newState;
    }
    return newState;
};
exports.beforeMaskedValueChange = beforeMaskedValueChange;
//# sourceMappingURL=DOBInput.utils.js.map